import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { DataSharingService } from '../../AuthGuard/DataSharingService';
import { MasterService } from '../../Shared/app.Masters.Service';
import { RequestModel } from '../../Shared/Models/app.MasterRequestModel';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { Router } from '@angular/router';
import { LosService } from '../../_LOS/services/los.service';
import { LmsService } from '../../_Lms/services/lms.service';
declare var $: any;
import { DialogService } from '../../Shared/dialog.service';

@Component({
  selector: 'app-collection-area',
  templateUrl: './collection-area.component.html',
  styleUrls: ['./collection-area.component.scss']
})
export class CollectionAreaComponent implements OnInit {

  private data: any; private _MasterService; showSpinner: boolean = false;
  private _LmsService;
  RequestModel: RequestModel = new RequestModel();
  ReportingManagerRequestModel: RequestModel = new RequestModel();
  CopyEmployeeRequestModel: RequestModel = new RequestModel();
  EmployeeProcessForCopyRequestModel: RequestModel = new RequestModel();
  SaveEmployeeDataRequestModel: RequestModel = new RequestModel();
  SaveEmployeeProfileRequestModel: RequestModel = new RequestModel();
  EmpDeleteAssBranchRequestModel: RequestModel = new RequestModel();
  EmpDeleteAssProcessRequestModel: RequestModel = new RequestModel();

  loading: boolean = false; CurrentDate: any = new Date();
  // register new role
  SelectArea: any = '';
  AreaName: any = '';
  SelectBranch: any = '';

  EmployeeId: any = 0;
  // bind data
  BranchesList: any = [];
  // copy employee
  applicationId: any = 95;
  areaId: number;
  dataCustomerSource: any;
  saveBtn: boolean = true;
  updateBtn: boolean = false;
  collectionArea = [
    {
      name: "Collection Area"
    },
    {
      name: "Source Area"
    }
  ]

  displayedCustomerColumns: string[] = ['Number', 'Area', 'SubArea', 'Branch', 'Action'];
  JsonData: any;

  constructor(private _Route: Router, private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar, private MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private dialog: DialogService
  ) {
    this._MasterService = MasterService;
    this._LmsService = LmsService;
    this.data = JSON.parse(sessionStorage.getItem('currentUser'));
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next('Area Master');
    // this._MasterService.GetRoleForDropdown().subscribe((result) => {
    //   this.RolesDropdownData = JSON.parse(JSON.stringify(result));
    // });

    this.LMS_GetAreaMaster();
    this.getBranchesList();
  }

  getBranchesList() {
    // this.showSpinner = true;
    this.RequestModel.ZoneId = 0;
    this.RequestModel.DistrictId = 0;
    this._MasterService.GetBranches(this.RequestModel).subscribe((result) => {
      this.BranchesList = JSON.parse(JSON.stringify(result));
      //this.dataSource = new MatTableDataSource(this.BranchesList);
      // this.showSpinner = false;
    });
  }

  LMS_GetAreaMaster() {
    this.showSpinner = true;
    this._LmsService.Get_Lms_Area().subscribe((response) => {
      console.log('Get_Lms_Area', response);
      this.dataCustomerSource = new MatTableDataSource(response);
      this.JsonData = response;
    });

  }

  onSaveArea() {
    let saveAreaDetail = {
      "Int_Id": 0,
      "IsActive": 1,
      "Type": this.SelectArea,
      "Area_Name": this.AreaName,
      "Branch_Id": this.SelectBranch,
    }
    this._LmsService.Save_Lms_Area(saveAreaDetail).subscribe((response) => {
      if (response[0].CODE == 0) {
        this.snackBar.openFromComponent(SnackbarComponent, { data: response[0].MSG, ...this.configSuccess });
        this.LMS_GetAreaMaster();
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: response[0].MSG, ...this.configSuccess });
      }
    });
  }

  removeCollectionArea(data: any) {
    this.dialog.openConfirmDialog(`Are you sure you want to delete this branch ${data.Branch_Name}.`)
      .afterClosed().subscribe(dialogResult => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          this._LmsService.Delete_Lms_Area({ Int_Id: data.Int_Id }).subscribe((res: any) => {
            this.showSpinner = false;
            if (res[0].CODE >= 0) {
              this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
              this.LMS_GetAreaMaster();
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
            }
          })
        }
      });
  }

  editCollectionArea(data: any) {
    this.AreaName = data.Name;
    this.SelectArea = data.Type.trim();
    this.SelectBranch = data.BranchId;
    this.areaId = data.Int_Id;
    this.saveBtn = false;
    this.updateBtn = true;
  }

  UpdateArea() {
    this.saveBtn = true;
    this.updateBtn = false;
    console.log('this.areaId', this.areaId);
    let updateAreaDetail = {
      "Int_Id": this.areaId,
      "IsActive": 1,
      "Type": this.SelectArea,
      "Area_Name": this.AreaName,
      "Branch_Id": this.SelectBranch,
    }
    this._LmsService.Save_Lms_Area(updateAreaDetail).subscribe((response) => {
      if (response[0].CODE == 0) {
        this.areaId = 0;
        this.snackBar.openFromComponent(SnackbarComponent, { data: response[0].MSG, ...this.configSuccess });
        this.LMS_GetAreaMaster();
        this.AreaName = '';
        this.SelectArea ='';
        this.SelectBranch ='';
        this.areaId =0;
        this.saveBtn = true;
        this.updateBtn = false;
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: response[0].MSG, ...this.configSuccess });
      }
    });
  }
  applyFilter(filterValue:string){
    this.dataCustomerSource.filter = filterValue.trim().toLowerCase();
  }


  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("collection-area-table") as HTMLTableElement;
    const worksheetName = "COLLECTION AREA EXPORT"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }




}
